module.exports = __webpack_public_path__ + "img/banner02.aeac539b.png";